<template>
    <div class="bcg">
        <div>
            <img src="../../assets/500.png" alt="" style="width:48%">
        </div>
        <div>
            <p>服務器出錯啦！</p>
            <p>500:服務器出錯，請聯繫管理員</p>
            <p ><a @click="goLast">返回上一頁></a></p>
            <p ><a  @click="goFirst()" >回到首頁></a></p>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
        methods:{
            goFirst(){
                this.$router.push('/dashboard')
            },
            goLast(){
                this.$router.go(-1)
            }
        }
    }
</script>
<style scoped>
    *{
        user-select: none;
    }
    .bcg {
        padding:120px 0px;
        /*width: 50%;*/
    }
    .bcg div{
        width: 100%;
    }
    .bcg div{
        text-align: center;
    }
    /*.bcg div:nth-child(2){*/
    /*   padding:200px 0px;*/
    /*}*/
    .bcg p:nth-child(1){
        font-size:30px;
        font-weight: bold;
        padding:3px 0px 15px 0px;
    }
    .bcg p:nth-child(2) a,.bcg p:nth-child(3) a{
        padding:0px 0px 5px 0px;
        cursor:pointer
    }
    .bcg p a{
        color: #00b3ee;
    }
</style>



// WEBPACK FOOTER //
// src/views/notFond/error.vue